/**
 * Onboarding wizard form contract — three steps:
 *  1. Identity  (name)
 *  2. Address   (street, city, country, postalCode)
 *  3. Branding  (logo URL) + review
 *
 * `maxEmployees` is intentionally NOT part of the onboarding wizard — only the
 * super-admin create flow sets that. Org admins finishing onboarding cannot
 * change their own seat limit.
 */
export type OnboardingFormValues = {
  name: string
  street: string
  city: string
  country: string
  postalCode: string
  logo: string
}

export const ONBOARDING_STEP_COUNT = 3
export type OnboardingStepIndex = 0 | 1 | 2

/** Fields a given step is responsible for — drives per-step react-hook-form validation. */
export const ONBOARDING_FIELDS_FOR_STEP: Record<OnboardingStepIndex, (keyof OnboardingFormValues)[]> = {
  0: ['name'],
  1: ['street', 'city', 'country', 'postalCode'],
  // Step 3 is a read-only review (logo onboarding hidden for now) — nothing to validate.
  2: []
}
